// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d09a90d4","977":"c57a3fbc"}[chunkId] + ".chunk.js";
};